import { OrdersDtoOrderLineDto } from "@springtree/eva-services-core";
import { useFormatter } from "next-intl";

import intlUtils from "~/utils/intl-utils";

import styles from "./cart-product-price.module.scss";

type Props = {
  line: OrdersDtoOrderLineDto & { display_price: number; original_price: number; currency_id: string };
};

export default function CartProductPriceLater(props: Props) {
  const { display_price, original_price, currency_id: currency } = props.line;

  const formatter = useFormatter();
  const priceFormatter = intlUtils.usePriceFormatter();

  return (
    <div className={styles.container}>
      {original_price ? (
        <del className={styles.originalPrice}>{priceFormatter.currency(original_price, { currency })}</del>
      ) : null}
      {original_price ? (
        <p className={styles.discount}>
          {formatter.number(display_price / original_price - 1, { style: "percent", maximumFractionDigits: 0 })}
        </p>
      ) : null}
      <p className={styles.displayPrice}>{priceFormatter.currency(display_price, { currency })}</p>
    </div>
  );
}
